export const OPTION_TYPE = {
  DELIVERY_OPTION: 'DELIVERY_OPTION',
  SERVICE_OPTION: 'SERVICE_OPTION',
  HAND_OFF_OPTION: 'HAND_OFF_OPTION',
}

export const DAY_EVENING_THRESHOLD = 17
